import React, { useContext, useState } from 'react';

export enum MessageTypes {
	success= 'success', error= 'error', warning= 'warning', info= 'info'
}

type TypeOfMessage = MessageTypes | undefined;

export interface NotificationContextData {
	message?: JSX.Element | string ;
	messageType: TypeOfMessage;
	showMessage(msg: JSX.Element | string, msgType?: TypeOfMessage  ): void;
	clearMessage(): void;
}

const NotificationContext = React.createContext<NotificationContextData>( {
	message: undefined,
	messageType: undefined,
	showMessage: () => { },
	clearMessage: () => { }
});

export interface NotificationProviderParams {
	children: JSX.Element | JSX.Element[];
}

export const useNotification = (): NotificationContextData => useContext(NotificationContext);

export const NotificationProvider = ({ children }: NotificationProviderParams ): JSX.Element => {

	const [message, setMessage] = useState<JSX.Element | string | undefined>(undefined);
	const [messageType, setMessageType] = useState<TypeOfMessage>(MessageTypes.info);

	const showMessage = (msg: JSX.Element | string, msgType?: TypeOfMessage ): void => {
		setMessage(msg);
		const inputMsgType = msgType ?? MessageTypes.info;
		if (inputMsgType !== messageType) {
			setMessageType(inputMsgType);
		}
	};
	const clearMessage = (): void => setMessage(undefined);

	return (
		<NotificationContext.Provider value={{showMessage, clearMessage, message, messageType }}>
			{children}
		</NotificationContext.Provider>
	);
};
